
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chapter",
      function () {
        return require("private-next-pages/chapter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chapter"])
      });
    }
  